import React, { useState, useEffect, useRef } from "react";

import MatDatagrid from "f1-mat-data-grid-react";

import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import { Paginator } from "../paginator";
import Loader from "../loader/loader";
import { ApiUrls } from "../../api/baseURL";
import { post } from "../../api/api";
import { metaDataConstants } from "../../utils/Constants/constants-en";

function AllNotifications() {
  const formRef = useRef();

  const [NoOfRecordperPage, setNoOfRecordperPage] = useState(100);

  const [notificationData, setNotificationData] = useState([]);
  const [activateLoader, setActivateLoader] = useState(false);
  let [rowPerPage, setRowPerPage] = useState(10);
  let [rowChangeEvent, setRowChangeEvent] = useState(0);
  let [totalCount, setTotalCount] = useState(0);
  let [initialPageNo, setInitialPageNo] = useState(0);

  const columns = [
    {
      title: "Notification ",
      field: "textBody",
      sorting: true,
    },
  ];

  const fetchBusinessLead = async (Page, rowPerPageCount) => {
    setActivateLoader(true);
    const payload = {
      userName: "test",
      tag: "WBC",
      IsActive: 1,
      pageSize: rowPerPageCount,
      pageNumber: Page,
      isRead: 0,
    };

    const response = await post(ApiUrls().GET_ALL_NOTIFICATION, payload)
      .catch(function (error) {
        // Handle errors here
        setActivateLoader(false);
        console.error("Error:", error);
      });

    if (response?.status === 200) {
      const responseData = [];
      for (const element of response?.data.result) {
        const match = element.textBody.match(/>([^<]+)<\/a>/);
        // Check if a match is found
        if (match && match[1]) {
          element.textBody = match[1].trim();
        } else {
          console.log("No match found.");
        }
        responseData.push(element);
      }
      setNotificationData(responseData);
      setActivateLoader(false);
      setTotalCount(response?.data.paging.totalCount);
    } else {
      setActivateLoader(false);
    }
  };

  useEffect(() => {
    fetchBusinessLead(1, rowPerPage);
  }, []);

  const handleChangeRowPer = async (e) => {
    const payload = {
      userName: "test",
      tag: "WBC",
      IsActive: 1,
      pageSize: e.target.value,
      pageNumber: 1,
      isRead: 0,
    };

    setRowPerPage(e.target.value);

    setActivateLoader(true);
    const response = await post(ApiUrls().GET_ALL_NOTIFICATION, payload)
      .catch(function (error) {
        // Handle errors here
        setActivateLoader(false);
        console.error("Error:", error);
      });

    if (response?.status === 200) {
      const responseData = [];
      for (const element of response?.data.result) {
        const match = element.textBody.match(/>([^<]+)<\/a>/);
        // Check if a match is found
        if (match && match[1]) {
          element.textBody = match[1].trim();
        } else {
          console.log("No match found.");
        }
        responseData.push(element);
      }
      setActivateLoader(false);
      setNotificationData(responseData);
      setRowChangeEvent(e.target.value);
      setTotalCount(response?.data.paging.totalCount);
      setNoOfRecordperPage(NoOfRecordperPage + 10);
    } else {
      setActivateLoader(false);
    }
  };

  const onChildMount = React.useCallback((dataFromChild) => {
    setInitialPageNo(dataFromChild);
  });
  const onChangePage = async (e, page) => {
    const payload = {
      userName: "test",
      tag: "WBC",
      IsActive: 1,
      pageSize: rowPerPage,
      pageNumber: page + 1,
      isRead: 0,
    };
    setActivateLoader(true);
    const response = await post(ApiUrls().GET_ALL_NOTIFICATION, payload)
      .catch(function (error) {
        // Handle errors here
        setActivateLoader(false);
        console.error("Error:", error);
      });

    if (response?.status === 200) {
      const responseData = [];
      for (const element of response?.data.result) {
        const match = element.textBody.match(/>([^<]+)<\/a>/);
        // Check if a match is found
        if (match && match[1]) {
          element.textBody = match[1].trim();
        } else {
          console.log("No match found.");
        }
        responseData.push(element);
      }
      setActivateLoader(false);
      setNotificationData(responseData);
      setTotalCount(response?.data.paging.totalCount);
      setNoOfRecordperPage(NoOfRecordperPage + 10);
    } else {
      setActivateLoader(false);
    }
  };

  return (
    <>
      <div className="container containerMainDiv">
        <div className="contentdivBg pt-0">

          <div className="divRound pt-3">
            <div className="clearfix"></div>
            <MatDatagrid
              rows={notificationData ? notificationData : []}
              columns={columns}
              props={{ labelRowsSelect: "records" }}
              search={false}
              grouping={false} //to show or hide grouping
              addRowPosition={"first"} //"last"
              treeView={false}
              selection={false}
              filtering={false}
              title={metaDataConstants.allNotifications}
              pageSize={rowPerPage}
              paging={false}
              pageSizeOptions={[15, 20, 25, 50]}
              showFirstLastPageButtons={false}
              paginationType={"normal"} //"normal" or "stepped"
              exportButton={false}
              exportAllData={true}
              customPagination={{
                isDisplay: true,
                totalCount: totalCount,
              }}
              editable={{
                showDelete: false,
              }}
              localization={{
                body: {
                  emptyDataSourceMessage: " ",
                },
              }}
            />

            <div className="paginListDiv">
              <div className="paginationDiv float-left">
                {totalCount && totalCount > 9 ? (
                  <>
                    <label for="selectRecordsPerPage">
                      {metaDataConstants.recordsPerPage} &nbsp;{" "}
                    </label>
                    <Select
                      value={rowPerPage}
                      onChange={(e) => handleChangeRowPer(e)}
                    >
                      <MenuItem value={10}>10</MenuItem>
                      <MenuItem value={20}>20</MenuItem>
                      <MenuItem value={30}>30</MenuItem>
                      <MenuItem value={40}>40</MenuItem>
                      <MenuItem value={50}>50</MenuItem>
                    </Select>
                  </>
                ) : (
                  ""
                )}
              </div>
              {totalCount != 0 ? (
                <Paginator
                  onMount={onChildMount}
                  rowCount={rowChangeEvent}
                  className="pagination"
                  totalRecoards={totalCount}
                  recordsPerPage={rowPerPage}
                  onPageChange={onChangePage}
                  maxPageLimit={5}
                  initialPage={initialPageNo}
                />
              ) : (
                ""
              )}
              <div className="clearfix"></div>
            </div>
            <div className="clearfix"></div>
          </div>
        </div>
      </div>
      <div></div> <Loader active={activateLoader} />
    </>
  );
}

export default AllNotifications;
